import React, { useCallback, useMemo } from 'react'
import { useTable } from 'hooks'
import { getColumns, getRowActions } from './model'
import { candidates } from 'orm'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentAccount } from 'ducks/auth'
import type { TableQuery } from 'hooks/useTable'

const useCandidatesTableQueries = () => {
  const dispatch = useDispatch()

  const handleFetchCandidates = React.useCallback(
    ({ workspaceId }, { limit, offset, ordering, search }) => {
      const workspaceExists = typeof workspaceId === 'number'

      if (workspaceExists) {
        dispatch(
          candidates.fetchStart({
            talent_assessment_workspace: workspaceId,
            limit,
            offset,
            ordering,
            search,
          }),
        )
      }
    },
    [dispatch],
  )

  return {
    handleFetchCandidates,
  }
}

export const useOverviewTable = ({ search }) => {
  const columns = useMemo(() => getColumns(), [])
  const rowActions = useMemo(() => getRowActions(), [])

  const account = useSelector(getCurrentAccount)

  const workspaceId = account?.talent_assessment_workspace?.id

  const data = useSelector(candidates.getModel)

  const { count, items } = data ?? {}

  const tableData = React.useMemo(() => Object.values(items ?? {}), [items])

  const { handleFetchCandidates } = useCandidatesTableQueries()

  const fetchAction = React.useCallback(
    ({ limit, offset, ordering, search }: TableQuery) => {
      handleFetchCandidates(
        { workspaceId },
        { limit, offset, ordering, search },
      )
    },
    [workspaceId, handleFetchCandidates],
  )

  const updateQueriesAction = useCallback(async () => {}, [])

  const stableSortingMap = useMemo(
    () => ({ name: 'name', created: 'created', progress: 'status' }),
    [],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: tableData,
    mapSortingPropToQueryParam: stableSortingMap,
    pageCount: count,
    search,
    fetchAction,
    updateQueriesAction,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: {
        headers,
        model,
        rowActions,
        isFetching,
      },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  }
}
